<template>
  <div class="input-group" :class="{ 'error': error }">
    <input 
      :type="showPassword ? 'text' : 'password'"
      :value="modelValue"
      :placeholder="placeholder"
      @input="handleInput"
      @blur="handleBlur"
      :disabled="disabled"
    />
    <div
      v-if="modelValue"
      class="password-toggle"
      @click="togglePasswordVisibility"
      aria-label="密码可见性切换"
    >
    <!-- :key 改变了 vnode 身份，强制重建实例 -->
    <!-- 主题适配：图标颜色跟随全局变量，避免浅色模式下过浅看不清 -->
      <CustomIcon 
        :key="showPassword ? 'setting-1-filled' : 'delet'"
        :config="{ attr: { cic_tp: 1, cic_sz: 24, cic_url: showPassword ? 'eye' : 'eyeInvisible', cic_c: 'var(--auth-icon)' } }" 
      />
    </div>
    <div v-if="modelValue && showClear"   class="delete-icon"   @click="clearPassword">
      <!-- 主题适配：图标颜色跟随全局变量，避免浅色模式下过浅看不清 -->
      <CustomIcon  :config="{ attr: {  cic_tp: 1, cic_sz: 24, cic_url: 'delet',  cic_c:  'var(--auth-icon)', },}"/> 
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
// 导入图片资源
import CustomIcon from 'd3components/src/components/item-d3/d3/d3_customIcon.vue';

export default defineComponent({
  name: 'PasswordInput',
  components: { CustomIcon },
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    error: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showClear: {
      type: Boolean,
      default: true
    }
  },
  emits: ['update:modelValue', 'blur', 'clear'],
  setup(_, { emit }) {
    // 密码可见性控制
    const showPassword = ref(false);

    // 切换密码可见性
    const togglePasswordVisibility = () => {
      showPassword.value = !showPassword.value;
    };

    // 处理输入
    const handleInput = (event: Event) => {
      const target = event.target as HTMLInputElement;
      emit('update:modelValue', target.value);
    };

    // 处理失焦
    const handleBlur = (event: Event) => {
      emit('blur', event);
    };

    // 清除密码
    const clearPassword = () => {
      emit('update:modelValue', '');
      emit('clear');
    };

    return {
      showPassword,
      togglePasswordVisibility,
      handleInput,
      handleBlur,
      clearPassword
    };
  }
});
</script>

<style lang="scss" scoped>
/* 主题适配：复用认证页输入框样式（含 theme-mode 下的变量） */
@use './shared/auth-common.scss';

/* 密码可见性切换 */
.password-toggle {
  position: absolute;
  right: 3rem;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  width: 1.5rem;
  height: 1.2rem;
  opacity: 0.6;
  transition: opacity 0.3s;
  z-index: 10;
}

.password-toggle:hover {
  opacity: 1;
}

/* 删除图标样式 */
.delete-icon {
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  width: 1.2rem;
  height: 1.2rem;
  cursor: pointer;
  opacity: 0.6;
  transition: opacity 0.3s;
  z-index: 10;
}

.delete-icon:hover {
  opacity: 1;
}
</style>